<template>
  <div>
    <Header />
    <div class="banner">
      <div class="container">
        <div class="banner-inner">
          <div class="banner-inner-h1">{{ $t("home.banner1") }}</div>
          <div class="banner-inner-h1 cblue">{{ $t("home.banner2") }}</div>
          <div class="banner-inner-text">
            {{ $t("home.banner3") }}
          </div>
          <div class="a" @click="handleScroll('contact-us')">
            <span>{{ $t("home.ref") }}</span> <i class="arrow-right"></i>
          </div>
          <img src="../assets/banner-bg2.png" />
        </div>
      </div>
    </div>
    <div id="product">
      <div class="container">
        <el-carousel
          :interval="3000"
          type="card"
          height="450px"
          indicator-position="none"
          arrow="never"
          @change="i => (carouselIndex = i)"
        >
          <el-carousel-item>
            <div
              class="carousel_item zoomIn animated"
              :class="{ active: carouselIndex == 0 }"
            >
              <div class="tit d-flex align-items-center">
                <div class="tit_code">01</div>
                <div>
                  <div class="tit_part">PART</div>
                  <div class="tit_t">{{ $t("home.part1.tit") }}</div>
                </div>
              </div>
              <div class="tips">{{ $t("home.part1.tips") }}</div>
              <div class="part1">
                <div
                  class="part-item d-flex align-items-center justify-content-center"
                >
                  <img src="../assets/icon1.png" width="57px" />
                  <p>
                    {{ $t("home.part1.p") }}
                  </p>
                </div>
                <div
                  class="part-item d-flex align-items-center justify-content-center"
                >
                  <img src="../assets/icon2.png" width="57px" />
                  <p>
                    {{ $t("home.part1.p2") }}
                  </p>
                </div>
                <div
                  class="part-item d-flex align-items-center justify-content-center"
                >
                  <img src="../assets/icon3.png" width="57px" />
                  <p>{{ $t("home.part1.p3") }}</p>
                </div>
              </div>
              <div class="btn" @click="handleScroll('acq')">
                {{ $t("home.part1.btn_txt") }}>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div
              class="carousel_item zoomIn animated"
              :class="{ active: carouselIndex == 1 }"
            >
              <div class="tit d-flex align-items-center">
                <div class="tit_code">02</div>
                <div>
                  <div class="tit_part">PART</div>
                  <div class="tit_t">{{ $t("home.part2.tit") }}</div>
                </div>
              </div>
              <div class="tips">{{ $t("home.part2.tips") }}</div>
              <div class="part2">
                <div class="part-item d-flex align-items-center">
                  <img src="../assets/icon4.png" width="51px" />
                  <div>
                    <p>{{ $t("home.part2.p") }}</p>
                    <p>{{ $t("home.part2.p2") }}</p>
                  </div>
                </div>
                <div class="part-item d-flex align-items-center">
                  <img src="../assets/icon5.png" width="51px" />
                  <div>
                    <p>{{ $t("home.part2.p3") }}</p>
                    <p>{{ $t("home.part2.p4") }}</p>
                    <p>{{ $t("home.part2.p5") }}</p>
                  </div>
                </div>
              </div>
              <div class="btn" @click="handleScroll('payment')">
                {{ $t("home.part1.btn_txt") }}>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div
              class="carousel_item zoomIn animated"
              :class="{ active: carouselIndex == 2 }"
            >
              <div class="tit d-flex align-items-center">
                <div class="tit_code">03</div>
                <div>
                  <div class="tit_part">PART</div>
                  <div class="tit_t">{{ $t("home.part3.tit") }}</div>
                </div>
              </div>
              <div class="tips">
                {{ $t("home.part3.tips") }}
              </div>
              <div class="part3">
                <div class="part-item d-flex">
                  <i />
                  <p>{{ $t("home.part3.p") }}</p>
                </div>
                <div class="part-item d-flex">
                  <i />
                  <p>
                    {{ $t("home.part3.p2") }}
                  </p>
                </div>
                <div class="part-item d-flex">
                  <i />
                  <p>
                    {{ $t("home.part3.p3") }}
                  </p>
                </div>
              </div>
              <div class="btn" @click="handleScroll('account')">
                {{ $t("home.part1.btn_txt") }}>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <section id="section1" class="p80">
      <div class="container pd-none">
        <div class="col-md-12 pd-none">
          <h2 class="subtitle">
            {{ $t("home.sec1.tit") }}
            <br v-if="$i18n.locale == 'en'" />
            <span>{{ $t("home.sec1.tit2") }}</span>
          </h2>
          <p class="tips">
            {{ $t("home.sec1.tips") }}
          </p>
          <div class="content">
            <div>
              <div class="d-flex align-items-center">
                <img src="@/assets/icon6.png" class="icon" />
                <div class="th2">{{ $t("home.sec1.subtit") }}</div>
              </div>
              <div class="mt-2 th4">
                {{ $t("home.sec1.subtit_p") }}
              </div>
            </div>
            <div class="mt-4">
              <div class="d-flex align-items-center">
                <img src="@/assets/icon7.png" class="icon" />
                <div class="th2">{{ $t("home.sec1.subtit2") }}</div>
              </div>
              <div class="mt-2 th4">
                {{ $t("home.sec1.subtit2_p") }}
              </div>
            </div>
          </div>
        </div>
        <div class="pic">
          <img src="@/assets/pic.png" height="527px" />
        </div>
      </div>
    </section>
    <section id="section2" class="p80">
      <div class="container pd-none">
        <div class="">
          <h2 class="subtitle">
            {{ $t("home.sec2.tit") }}
            <br v-if="$i18n.locale == 'en'" />
            <span>{{ $t("home.sec2.tit2") }}</span>
          </h2>
          <p class="tips">
            {{ $t("home.sec2.tips") }}
          </p>
          <div class="box">
            <div
              class="item part1"
              :class="{ mouseover: partId == 1 }"
              @mouseover="partId = 1"
            >
              <div class="th2">
                {{ $t("home.sec2.part1.tit") }}<br />{{
                  $t("home.sec2.part1.tit2")
                }}
              </div>
              <div class="tips">
                {{ $t("home.sec2.part1.tips") }}<br />{{
                  $t("home.sec2.part1.tips2")
                }}
              </div>
            </div>
            <div
              class="item part2"
              :class="{ mouseover: partId == 2 }"
              @mouseover="partId = 2"
            >
              <div class="th2">
                {{ $t("home.sec2.part2.tit") }}<br />{{
                  $t("home.sec2.part2.tit2")
                }}
              </div>
              <div class="tips">
                {{ $t("home.sec2.part2.tips") }} <br />{{
                  $t("home.sec2.part2.tips2")
                }}
              </div>
            </div>
            <div
              class="item part3"
              :class="{ mouseover: partId == 3 }"
              @mouseover="partId = 3"
            >
              <div class="th2">
                {{ $t("home.sec2.part3.tit") }} <br />{{
                  $t("home.sec2.part3.tit2")
                }}
              </div>
              <div class="tips">
                {{ $t("home.sec2.part3.tips") }} <br />{{
                  $t("home.sec2.part3.tips2")
                }}
              </div>
            </div>
            <div
              class="item part4"
              :class="{ mouseover: partId == 4 }"
              @mouseover="partId = 4"
            >
              <div class="th2">
                {{ $t("home.sec2.part4.tit") }} <br />{{
                  $t("home.sec2.part4.tit2")
                }}
              </div>
              <div class="tips">
                {{ $t("home.sec2.part4.tips") }} <br />{{
                  $t("home.sec2.part4.tips2")
                }}
              </div>
            </div>
          </div>
          <div class="content" @click="handleScroll('contact-us')">
            <div class="th2">{{ $t("home.con_t") }}</div>
            <div class="th3">{{ $t("home.con_t2") }}</div>
            <div class="btn" @click="handleScroll('contact-us')">
              <span>{{ $t("home.ref") }}</span> <i class="arrow-right"></i>
            </div>
            <img src="../assets/pic2.png" width="1200" class="pic" />
          </div>
        </div>
      </div>
    </section>
    <section id="news">
      <div class="container">
        <div class="news">
          <div class="th2">{{ $t("home.news.tit") }}</div>
          <div class="d-flex">
            <div class="news-l">
              <div>
                <img :src="require(`@/assets/${news[0].pic}`)" width="346px" />
              </div>
              <div class="th3">
                {{ news[0].tit }}
              </div>
              <div class="th4">
                {{ news[0].year }}-{{ news[0].month }}-{{ news[0].day }}
              </div>
              <div class="p">
                {{ news[0].txt }}
              </div>
            </div>
            <!-- <div class="news-l">
              <div><img src="@/assets/news.png" width="346px" /></div>
              <div class="th3">
                促进中哈经贸合作，“数贸之夜”上，这两个项目签约
              </div>
              <div class="th4">2024-09-25</div>
              <div class="p">
                9月25日至29日，第三届全球数字贸易博览会在杭举行。在25日晚举行的“数贸之夜”活动中，科里扎特智慧化口岸项目、中哈人民币结算及跨境支付项目签约。
              </div>
            </div> -->
            <div class="news-r">
              <div
                class="news-r-item"
                v-for="(n, i) in news"
                :key="i"
                @click="openNews(i)"
              >
                <div class="news-date">
                  <div class="day">{{ n.day }}</div>
                  <div class="month">{{ n.year }}/{{ n.month }}</div>
                </div>
                <div class="news-txt">
                  {{ n.tit }}
                </div>
              </div>
              <!-- <div class="news-r-item" @click="handleScroll('news')">
                <div class="news-date">
                  <div class="day">26</div>
                  <div class="month">2024/9</div>
                </div>
                <div class="news-txt">
                  促进中哈经贸合作，“数贸之夜”上，这两个项目签约
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="address">
      <div class="container">
        <div class="d-flex">
          <div class="address">
            <!-- <div
              class="add_item"
              :class="{ active: currentKey == 'a1' }"
              @click="currentKey = 'a1'"
            >
              <div class="th2"><i></i>中国总部</div>
              <div class="add_info">
                <p>Zantech  Limited</p>
                <p>联系电话：0571-87175575</p>
                <p>邮箱地址：info@zxfintec.com</p>
                <p>
                  公司地址：杭州市余杭区良渚街道金昌路2800号（洋帆中心）7号楼
                </p>
              </div>
            </div> -->
            <div
              class="add_item"
              :class="{ active: currentKey == 'a2' }"
              @click="currentKey = 'a2'"
            >
              <div class="th2"><i></i>{{ $t("address.hk") }}</div>
              <div class="add_info">
                <p>Singloh Technology Limited</p>
                <div class="d-flex">
                  <p>{{ $t("address.address") }}：</p>
                  <p>
                    Room No.05 15/F <br />
                    Radio City <br />
                    505-511 Hennesy Road <br />
                    Causeway Bay<br />
                    Hong Kong
                  </p>
                </div>
              </div>
            </div>
            <!-- <div
              class="add_item"
              :class="{ active: currentKey == 'a3' }"
              @click="currentKey = 'a3'"
            >
              <div class="th2"><i></i>尼日利亚</div>
              <div class="add_info">
                <p>BUD Infrastructure Limited</p>
                <div class="d-flex">
                  <p>公司地址：</p>
                  <p>
                    21B Fatai Idowu Arobieke St<br />
                    Lekki Phase 1<br />
                    Lagos<br />
                    Nigeria
                  </p>
                </div>
              </div>
            </div> -->
            <!-- <div
              class="add_item"
              :class="{ active: currentKey == 'a4' }"
              @click="currentKey = 'a4'"
            >
              <div class="th2"><i></i>坦桑尼亚</div>
              <div class="add_info">
                <p>MONEYPESA TANZANIA LIMITED</p>
                <div class="d-flex">
                  <p>公司地址：</p>
                  <p>
                    House 47 Block 47<br />
                    Makumbusho<br />
                    Dar es Salaam<br />
                    Tanzania
                  </p>
                </div>
              </div>
            </div> -->
            <!-- <div
              class="add_item"
              :class="{ active: currentKey == 'a5' }"
              @click="currentKey = 'a5'"
            >
              <div class="th2"><i></i>哈萨克斯坦</div>
              <div class="add_info">
                <p>Hong Kong KZPAY Technology Limited</p>
              </div>
            </div> -->
            <!-- <div
              class="add_item"
              :class="{ active: currentKey == 'a6' }"
              @click="currentKey = 'a6'"
            >
              <div class="th2"><i></i>新加坡</div>
              <div class="add_info">
                <p>ZANTECH INNOVATION PTE. LTD.</p>
                <div class="d-flex">
                  <p>公司地址：</p>
                  <p>
                    112 ROBINSON ROAD<br />
                    #03-01<br />
                    ROBINSON 112<br />
                    SINGAPORE (068902)
                  </p>
                </div>
              </div>
            </div> -->
          </div>
          <div class="map">
            <div v-for="(ad, key) in address" :key="key">
              <div
                class="circle"
                :style="{ top: ad.x + 'px', left: ad.y + 'px' }"
                @click="currentKey = key"
              >
                <div v-if="key == currentKey" class="check">
                  <div class="wave"></div>
                </div>
                <div v-else class="dot"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import "@/assets/css/animate.css";
import news from "./newsJson.js";
export default {
  name: "personal",
  components: { Header, Footer },
  data() {
    return {
      activeId: "#section",
      channel: this.$route.query.channel,
      httpIp: "https://naps.zxszkj.com",
      carouselIndex: 0,
      partId: "1",
      currentKey: "a2",
      address: {
        // a1: { x: 127, y: 535, name: "中国总部" },
        a2: { x: 162, y: 518, name: "香港" }
        // a3: { x: 188, y: 323, name: "尼日利亚" },
        // a4: { x: 213, y: 391, name: "坦桑尼亚" },
        // a5: { x: 109, y: 428, name: "哈萨克斯坦" },
        // a6: { x: 203, y: 518, name: "新加坡" }
      },
      timer: null,
      news
    };
  },
  watch: {
    // 监听器会在表达式的值变化后执行
    currentKey: {
      handler: function() {
        clearInterval(this.timer);
        // this.timer = setInterval(this.nextKey, 3000);
      },
      immediate: true // 组件加载立即执行一次
    }
  },
  mounted() {
    console.log(this.$t("message.hello"));
  },
  methods: {
    handleScroll(domId) {
      switch (domId) {
        case "index":
          this.$router.push("/");
          break;
        case "login":
          const url = "https://dashboard.zantechglobal.com/#/login";
          window.open(url);
          break;
        case "develop":
          const url2 =
            "https://documenter.getpostman.com/view/32291077/2sA3sAi7rD";
          window.open(url2);
          break;
        default:
          this.$router.push(`/${domId}`);
          break;
      }
    },
    nextKey() {
      const keys = Object.keys(this.address);
      const currentIndex = keys.findIndex(key => key === this.currentKey);
      const nextIndex = (currentIndex + 1) % keys.length;
      console.log(nextIndex);
      this.currentKey = keys[nextIndex];
    },
    openNews(i) {
      this.$router.push({ path: "/newsDetails", query: { i } });
    }
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    clearInterval(this.timer);
  }
};
</script>

<style lang="less" scoped>
.p80 {
  padding: 80px 0;
}
.subtitle {
  font-weight: 300;
  font-size: 64px;
  color: #000000;
  line-height: 78px;
  span {
    color: #1485ef;
  }
}
.tips {
  font-weight: 400;
  font-size: 18px;
  color: #9e9e9e;
  line-height: 27px;
}
.arrow-right {
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 12px;
  height: 12px;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #fff;
  transform: translate(0, -50%) rotate(-135deg);
}

.banner {
  margin-top: 61px;
  height: 500px;
  background-image: url(../assets/banner-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  .container {
    position: relative;
  }
  .banner-inner {
    padding-top: 60px;
    color: #fff;
    .banner-inner-h1 {
      font-size: 64px;
      line-height: 87px;
      font-weight: 300;
      &.cblue {
        color: #1fb3f9;
        margin-bottom: 30px;
      }
    }
    .banner-inner-text {
      margin-bottom: 30px;
      width: 700px;
      font-weight: 350;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.72);
      line-height: 28px;
    }
    .a {
      position: relative;
      display: inline-block;
      padding: 10px 40px 10px 20px;
      background: linear-gradient(
        270deg,
        rgba(20, 133, 239, 0) 0%,
        rgba(20, 133, 239, 0.7) 100%
      );
      border-radius: 27px;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      cursor: pointer;
      box-sizing: border-box;
      span {
        margin-right: 16px;
      }
    }
    img {
      position: absolute;
      top: 134px;
      left: 500px;
      width: 472px;
      height: 152px;
    }
  }
}

#product {
  display: flex;
  align-items: center;
  height: 560px;
  .carousel_item {
    margin: 0 auto;
    padding: 20px;
    width: 335px;
    background: rgba(255, 255, 255, 0.89);
    box-shadow: 0px 4px 94px -37px #8998a7;
    border-radius: 25px 25px 25px 25px;
    border: 2px solid #ffffff;
    &.active {
      position: relative;
      .tit {
        .tit_code {
          color: #1485ef;
        }
        .tit_part {
          color: rgba(20, 133, 239, 0.35);
        }
        .tit_t {
          color: #1485ef;
        }
      }
      .btn {
        color: #1485ef;
        cursor: pointer;
      }
    }
    .tit {
      .tit_code {
        font-weight: 700;
        font-size: 70px;
        color: #919191;
        line-height: 72px;
      }
      .tit_part {
        font-weight: 700;
        font-size: 24px;
        color: rgba(201, 201, 201, 0.35);
        line-height: 36px;
      }
      .tit_t {
        font-weight: 300;
        font-size: 22px;
        color: #919191;
        line-height: 36px;
      }
    }
    .tips {
      font-weight: 400;
      font-size: 18px;
      color: #9e9e9e;
      line-height: 27px;
    }
    .part-item {
      p {
        margin-bottom: 0;
        font-weight: 400;
        font-size: 14px;
        color: #9e9e9e;
        line-height: 18px;
      }
    }
    .part1 {
      margin-top: 16px;
      margin-bottom: 14px;
      .part-item {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        p {
          margin-left: 18px;
          width: 193px;
        }
      }
    }

    .btn {
      margin: 0 auto;
      display: block;
      font-weight: 400;
      font-size: 14px;
      color: #919191;
      line-height: 20px;
      cursor: pointer;
    }
    .part2 {
      margin-top: 19px;
      .part-item {
        margin-bottom: 16px;
        width: 289px;
        height: 103px;
        background-image: url("../assets/product_bg1.png");
        background-repeat: no-repeat;
        background-size: cover;
        img {
          margin: 0 7px 0 15px;
        }
        p {
          margin-bottom: 0;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          line-height: 28px;
        }
        &:last-child {
          background-image: url("../assets/product_bg2.png");
        }
      }
    }
    .part3 {
      margin-top: 16px;
      margin-bottom: 69px;
      i {
        margin-top: 5px;
        margin-right: 12px;
        width: 17px;
        height: 6px;
        background: #1485ef;
        border-radius: 10px;
      }
      .part-item {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        p {
          width: 250px;
        }
      }
    }
  }
}

#section1 {
  height: 700px;
  background: rgb(244, 244, 244);
  .container {
    position: relative;
  }
  .th2 {
    margin-left: 5px;
    font-weight: 350;
    font-size: 36px;
    color: #000000;
    line-height: 36px;
  }
  .icon {
    margin: 0 12px 0 3px;
    width: 40px;
    height: 40px;
  }
  .th4 {
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #3b3b3b;
  }
  .content {
    margin-top: 60px;
    width: 417px;
  }
  .pic {
    position: absolute;
    top: 80px;
    left: 450px;
    height: 100%;
  }
}

#section2 {
  height: 1294px;
  .container {
    padding: 0;
  }
  .box {
    display: flex;
    align-items: center;
    .item {
      margin-right: 20px;
      padding: 30px;
      width: 208px;
      height: 360px;
      border-radius: 25px 25px 25px 25px;
      background-repeat: no-repeat;
      background-size: cover;
      cursor: pointer;
      &.part1 {
        background-image: url(../assets/part1-dis.png);
        background-size: 278px 430px;
        background-position: -35px -20px;
      }
      &.part2 {
        background-image: url(../assets/part2-dis.png);
        background-size: 278px 430px;
        background-position: -35px -20px;
      }
      &.part3 {
        background-image: url(../assets/part3-dis.png);
        background-size: 278px 430px;
        background-position: -35px -20px;
      }
      &.part4 {
        background-image: url(../assets/part4-dis.png);
        background-size: 278px 430px;
        background-position: -35px -20px;
      }
      .th2 {
        font-weight: 700;
        font-size: 28px;
        color: #7291ad;
        line-height: 34px;
      }
      .tips {
        margin-top: 168px;
        display: none;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 32px;
      }
      &.mouseover {
        width: 300px;
        height: 360px;
        &.part1 {
          background-image: url(../assets/part1.png);
          background-size: 370px 430px;
          background-position: -35px -20px;
        }
        &.part2 {
          background-image: url(../assets/part2.png);
          background-size: 370px 430px;
          background-position: -35px -20px;
        }
        &.part3 {
          background-image: url(../assets/part3.png);
          background-size: 370px 430px;
          background-position: -35px -20px;
        }
        &.part4 {
          background-image: url(../assets/part4.png);
          background-size: 370px 430px;
          background-position: -35px -20px;
        }
        .th2 {
          color: #fff;
        }
        .tips {
          display: block;
        }
      }
    }
  }
  .content {
    position: relative;
    padding-top: 163px;
    padding-left: 29px;
    cursor: pointer;
    .th2 {
      font-weight: 300;
      font-size: 42px;
      color: #1485ef;
      line-height: 51px;
    }
    .th3 {
      font-weight: 300;
      font-size: 42px;
      line-height: 51px;
      color: #000000;
    }
    .btn {
      position: relative;
      margin-top: 45px;
      padding: 10px 40px 10px 20px;
      background: linear-gradient(270deg, #1485ef 0%, #1485ef 100%);
      border-radius: 30px;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      cursor: pointer;
      span {
        margin-right: 10px;
      }
    }
    .pic {
      position: absolute;
      top: -60px;
      left: 168px;
    }
  }
}

#news {
  padding-top: 70px;
  background: #f4f4f4;
  .news {
    .th2 {
      font-size: 64px;
      color: #1485ef;
      line-height: 78px;
      font-weight: 300;
    }
    .d-flex {
      margin-top: 24px;
    }
    .news-l {
      border-right: 1px solid #d8d8d8;
      width: 400px;
      padding: 27px 60px 35px 0;
      img {
        height: 130px;
        border-radius: 10px;
      }
      .th3 {
        margin-top: 23px;
        font-weight: 700;
        font-size: 18px;
        color: #3e3e3e;
        line-height: 22px;
      }
      .th4 {
        margin: 8px 0;
        font-weight: 400;
        font-size: 12px;
        color: rgba(158, 158, 158, 0.37);
        line-height: 18px;
      }
      .p {
        font-weight: 400;
        font-size: 12px;
        color: #9e9e9e;
        line-height: 18px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .news-r {
      padding-left: 54px;
      padding-top: 12px;
      .news-r-item {
        position: relative;
        display: flex;
        align-items: center;
        height: 100px;
        cursor: pointer;
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 387px;
          height: 1px;
          background: #d8d8d8;
        }
        .news-date {
          width: 54px;
          height: 54px;
          background: #ffffff;
          border-radius: 10px;
          text-align: center;
          .day {
            font-weight: 700;
            font-size: 30px;
            color: #9e9e9e;
            line-height: 36px;
          }
          .month {
            font-weight: 700;
            font-size: 9px;
            color: #9e9e9e;
            line-height: 11px;
          }
        }
        .news-txt {
          margin-left: 19px;
          width: 400px;
          font-weight: 700;
          font-size: 18px;
          color: #3e3e3e;
          line-height: 22px;
        }
      }
    }
  }
}

#address {
  height: 540px;
  background: #f4f4f4;
  .container {
    padding: 0;
  }
  .address {
    margin-top: 90px;
    margin-right: 16px;
    .add_item {
      margin-bottom: 10px;
      .th2 {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: #8d8d8d;
        line-height: 29px;
        cursor: pointer;
        i {
          margin-right: 9px;
          display: block;
          width: 10px;
          height: 10px;
          background: #c9c9c9;
          border-radius: 10px;
        }
      }
      .add_info {
        display: none;
        margin-left: 19px;
        width: 280px;
        p {
          margin-bottom: 0;
          font-weight: 400;
          font-size: 14px;
          color: #8d8d8d;
          line-height: 29px;
        }
      }
      &.active {
        .th2 {
          color: #1485ef;
          i {
            background: #1485ef;
          }
        }
        .add_info {
          display: block;
        }
      }
    }
  }
  .map {
    position: relative;
    margin-top: 109px;
    width: 682px;
    height: 345px;
    background: url(../assets/map.png) no-repeat;
    background-size: cover;
    .circle {
      position: absolute;
      cursor: pointer;
      .dot {
        width: 10px;
        height: 10px;
        background: #ffffff;
        border: 2px solid #1485ef;
        border-radius: 50%;
      }
      .check {
        transform: translate(-2.5px, -2.5px);
        width: 15px;
        height: 15px;
        background: #1485ef;
        border-radius: 50%;
        .wave {
          position: absolute;
          top: 0;
          left: 0;
          transform: translate(-50%, -50%);
          width: 15px;
          height: 15px;
          background: #1485ef;
          border-radius: 50%;
          animation: pulse 3s infinite;
        }
      }
    }
    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      100% {
        transform: scale(2);
        opacity: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue